<template>
	<div class="">
		<form v-if="mode == 'create'" action="#" @submit.prevent>
			<h6 class="font-weight-bold">CREATE MENU</h6>

			<div class="col-md-12 form-group mb-4">
				<label> Menu Name: </label>
				<input class="form-control form-control-sm" type="text" placeholder="Enter menu title" v-model.trim="$v.formInfo.menuName.$model"  :class="{'is-invalid':$v.formInfo.menuName.$error}">
			</div>

			<div class="col-md-12 form-group mb-3">
				<label class=""> Has Sub-menu: </label><br>
				<div class="form-check form-check-inline">
					<input v-model.trim="$v.formInfo.hasSubMenu.$model" class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="1">
					<label class="form-check-label" for="inlineRadio1">Yes</label>
				</div>
				<div class="form-check form-check-inline">
					<input v-model.trim="$v.formInfo.hasSubMenu.$model" class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="0">
					<label class="form-check-label" for="inlineRadio2">No</label>
				</div>
			</div>

			<div class="col-md-12 form-group mb-5">
				<label> Menu URL: </label>
				<input class="form-control form-control-sm" :disabled="formInfo.hasSubMenu == 1" type="text" placeholder="Enter your url" v-model.trim="$v.formInfo.menuUrl.$model"  :class="{'is-invalid':$v.formInfo.menuUrl.$error}">
			</div>

			<div class="form-group mb-3 text-center px-3">
				<button class="btn btn-primary btn-sm w-100" :disabled="$v.formInfo.$invalid || creating" type="submit" @click.prevent="createMenu()"> 
					<span class="mr-3">Create Menu</span>
					<span v-if="creating" class="spinner-border spinner-border-sm" role="status">
						<span class="sr-only">Loading...</span>
					</span>
				</button>
			</div>
		</form>

		<form v-else action="#" @submit.prevent>
			<h6 class="font-weight-bold">UPDATE MENU</h6>

			<input type="hidden" name="" v-model.trim="$v.menuData.menuId">

			<div class="col-md-12 form-group mb-4">
				<label> Menu Name: </label>
				<input class="form-control form-control-sm" type="text" placeholder="Enter menu title" v-model.trim="$v.menuData.menuName.$model"  :class="{'is-invalid':$v.menuData.menuName.$error}">
			</div>

			<div class="col-md-12 form-group mb-3">
				<label class=""> Has Sub-menu? : </label><br>
				<div class="form-check form-check-inline">
					<input v-model.trim="$v.menuData.hasSubMenu.$model" class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="1">
					<label class="form-check-label" for="inlineRadio1">Yes</label>
				</div>
				<div class="form-check form-check-inline">
					<input v-model.trim="$v.menuData.hasSubMenu.$model" class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="0">
					<label class="form-check-label" for="inlineRadio2">No</label>
				</div>
			</div>

			<div class="col-md-12 form-group mb-5">
				<label> Menu URL: </label>
				<input class="form-control form-control-sm" :disabled="menuData.hasSubMenu == 1" type="text" placeholder="Enter your url" v-model.trim="$v.menuData.menuUrl.$model"  :class="{'is-invalid':$v.menuData.menuUrl.$error}">
			</div>

			<div class="row justify-content-between mx-3">
				<button class="btn btn-secondary btn-sm px-5" type="submit" @click="$emit('showcreatemenu')"> 
					Go to Create Menu
				</button>

				<button class="btn btn-primary btn-sm px-5" :disabled="$v.menuData.$invalid || creating" type="submit" @click.prevent="updateMenu()"> 
					<span class="mr-3">Update Menu</span>
					<span v-if="creating" class="spinner-border spinner-border-sm" role="status">
						<span class="sr-only">Loading...</span>
					</span>
				</button>
			</div>
		</form>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
export default {
	name: "CreateMenu",
	data() {
		return {
			creating: false,
			formInfo: {
				menuName: null,
				menuUrl: null,
				hasSubMenu: 1,
			}
		}
	},

	props: {
		mode: String,
		menuData: Object
	},

	computed: {
        ...mapState(['token']),
    },

	validations: {
		formInfo: {
			menuName: {required},
			menuUrl: {},
			hasSubMenu: {required},
		},
		menuData:{
			menuId: { required },
			menuName: { required },
			menuUrl: {},
			hasSubMenu: {required}
		}
	},

	methods: {
		createMenu(){
			this.$v.formInfo.$touch();
			if (!this.$v.formInfo.$invalid && !this.$v.formInfo.$error) {
				// send the request for creating
				this.creating = true;

				const baseU = `${this.$urlAuth}/mainmenu/create`;
				this.$http.post(baseU, this.formInfo, {
					headers:{
                        "x-access-token":this.token
                    }
				})
				.then((result) => {
					this.creating=false;
					if(result.data.data.code =='S201'){
						this.$toastr.s(result.data.data.message);
						
						// Add data to the Menu List
						// TODO get the new created menu from Nonso
						const menuObj = result.data.data.menu;
						this.$emit('addtomenu', menuObj);

						// clear the fields
						this.formInfo.menuName = null;
						this.formInfo.menuUrl = null;
						this.formInfo.hasSubMenu = 1;
					}else{
						this.$toastr.e(result.data.data.message);
					}
				}).catch(er =>{
					console.log(er);
					this.creating=false;
					if(er.message == 'Network Error'){
						this.$toastr.e("Cannot connect to serve. Check your internet connection");
					}else{
						this.$toastr.e(er.message);
					}
				})
			}else{
				this.$toastr.e("Fill all fields well");
				return;
			}
		},

		updateMenu(){
			this.$v.menuData.$touch();
			if (!this.$v.menuData.$invalid && !this.$v.menuData.$error) {
				// send the request for creating
				this.creating = true;

				const baseU = `${this.$urlAuth}/mainmenu/edit`;
				this.$http.post(baseU, this.menuData, {
					headers:{
                        "x-access-token":this.token
                    }
				})
				.then((result) => {
					this.creating=false;
					if(result.data.data.code =='S200'){
						this.$toastr.s(result.data.data.message);
						
						// Add data to the Menu List
						const menuObj = {
							menuId: this.menuData.menuId,
							menuName: this.menuData.menuName,
							menuUrl: (this.menuData.hasSubMenu == 0)?this.menuData.menuUrl: "",
							hasSubMenu: this.menuData.hasSubMenu,
						};
						this.$emit('updatemenulist', menuObj);

					}else{
						this.$toastr.e(result.data.data.message);
					}
				}).catch(er =>{
					console.log(er);
					this.creating=false;
					if(er.message == 'Network Error'){
						this.$toastr.e("Cannot connect to serve. Check your internet connection");
					}else{
						this.$toastr.e(er.message);
					}
				})
			}else{
				this.$toastr.e("Fill all fields well");
				return;
			}
		},
	}
}
</script>